import styled from"@emotion/styled";import{mediaHeightQuery,mediaQuery}from"@wp/src/components/common/grid";export const AIAssistantOverlayContainer=styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  box-shadow: 0 16px 32px 0 rgba(15, 23, 42, 0.16);

  & > div {
    z-index: 1000;
    ${mediaQuery({width:["90vw","500px"]})}
  }
  .react-chatbot-kit-chat-message-container {
    ${mediaHeightQuery({height:["auto"],maxHeight:["calc(var(--full-vh, 100vh))","calc(var(--full-vh, 100vh))","calc(var(--vh, 1vh) * 80)"]})}
  }
`;export const AIAssistantContainer=styled.div`
  transition: height 0.3s ease-in-out;
  background: white;
  border-radius: var(--card-border-radius, 8px);
  box-shadow: rgba(15, 23, 42, 0.16) 0 2px 4px;
  justify-content: center;
  padding-top: 16px;

  .react-chatbot-kit-chat-container {
    width: 100%;

    .react-chatbot-kit-chat-inner-container {
      ${mediaHeightQuery({height:["auto"]})}
    }

    .react-chatbot-kit-chat-message-container {
      & > * {
        margin-top: 8px;
        margin-bottom: 8px;
      }
      & > :last-child {
        margin-bottom: 32px;
        padding: 40px;
      }

      min-height: 200px;
      overflow: auto;

      .react-chatbot-kit-chat-bot-message-container {
        margin: 0;
        color: ${({theme})=>theme.colors.neutral800};
        font-size: 14px;
      }

      .react-chatbot-kit-user-chat-message-container {
        margin: 0;
        .react-chatbot-kit-user-chat-message {
          background-color: ${({theme})=>theme.colors.blue50};
          font-weight: 400;
          font-size: 14px;
          color: ${({theme})=>theme.colors.neutral800};
        }
      }

      ul {
        margin-top: 0;
        margin-bottom: 10px;
      }

      p {
        margin: 0 0 8px 0;
      }

      a {
        display: inline-block;
        color: ${({theme})=>theme.colors.blue700};
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .react-chatbot-kit-chat-input-container {
      border: none;
      padding: 8px;
      border-radius: var(--card-border-radius, 8px);
      background-color: ${({theme})=>theme.colors.white};

      .react-chatbot-kit-chat-input-form {
        width: 100%;
        padding: 0;
        display: inline-flex;
        flex-wrap: nowrap;
        column-gap: 16px;
        .react-chatbot-kit-chat-btn-send {
          border-radius: 8px;
          width: 60px;
          background-color: ${({theme})=>theme.colors.green600};
          cursor: pointer;
          :disabled {
            background-color: ${({theme})=>theme.colors.green100};
            cursor: not-allowed;
          }
        }

        .react-chatbot-kit-chat-input {
          flex: 1;
          border-radius: 8px;
          padding-right: 16px;
          border: ${({theme})=>`1px solid ${theme.colors.neutral300}`};
          &:disabled {
            background-color: ${({theme})=>theme.colors.neutral100};
            cursor: not-allowed;
          }
        }

        .react-chatbot-kit-chat-input:focus-visible {
          outline: none;
        }
      }
    }

    .react-chatbot-kit-chat-input::placeholder {
      color: ${({theme})=>theme.colors.neutral400};
      font-size: 16px;
    }
  }
`;